import { render, staticRenderFns } from "./PaymentsList.vue?vue&type=template&id=51a35987"
import script from "./PaymentsList.vue?vue&type=script&lang=js"
export * from "./PaymentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports